/**
 * @generated SignedSource<<9c3bd451888035f10283f83073d1fc19>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hubQRLandingPageQuery$variables = {
  hubMetaName: string;
};
export type hubQRLandingPageQuery$data = {
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
    };
  };
};
export type hubQRLandingPageQuery = {
  response: hubQRLandingPageQuery$data;
  variables: hubQRLandingPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubMetaName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubMetaName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hubQRLandingPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v2/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "hubQRLandingPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a35425657b3d845743b468bb19fee09",
    "id": null,
    "metadata": {},
    "name": "hubQRLandingPageQuery",
    "operationKind": "query",
    "text": "query hubQRLandingPageQuery(\n  $hubMetaName: String!\n) {\n  hubMeta(by: {name: $hubMetaName}) {\n    hub {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3e1d58ba20422deba207ca4408d6a901";

export default node;
